export default {
  getBlankError() {
    return Promise.fail({
      status: 500,
      message: 'Error'
    })
  },
  getBlank() {
    return Promise.resolve({
      id: '9766',
      token: '5e4a5761b5a97',
      representative_id: '7264',
      accepted_by_customer_at: '2020-02-21 14:33:13',
      accepted_by_manager_at: null,
      currentStep: 1,
      lastStepTaken: 7,
      last_step_taken_at: '2020-02-21 14:33:13',
      blank_sent_at: '2020-02-17 10:05:37',
      status: '10',
      status_change_at: null,
      tm_company_id: null,
      blank_name: 'SELF SERVICE[9766] test@test.pl',
      blank_email: 'test@test.pl',
      customer_id: null,
      first_payment_value: '7050.00',
      monthly_declaration_calculation: '14100.00',
      customer_note: '',
      flotex_note: null,
      name: 'Firmat testowa',
      // "name": null,
      shortname: null,
      address: 'UL. LEŚNA 5',
      city: 'RZESZÓW',
      post: 'RZESZÓW',
      zip: '35-059',
      province: 'podkarpackie',
      serviceRecipient: null,
      serviceAddress: null,
      serviceCity: null,
      servicePost: null,
      serviceZip: null,
      contactName: 'JAN KOWALSKI',
      contactPhone: null,
      contactMobile: '+48 510-512-510',
      contactMobileAlt: null,
      contactEmail: 'test@test.pl',
      economicActivityForm: 1,
      nip: '5252608643',
      regon: '360758413',
      rbe: '0000541974',
      court:
        'S\u0105d Rejonowy dla \u0141odzi-\u015ar\u00f3dmie\u015bcia w \u0141odzi, XX Wydzia\u0142 Gospodarczy',
      contractRepresentatives: {
        representative_0: {
          person: 'JAN KOWALSKI - DYREKTOR'
        }
      },
      cards: {
        card_0: {
          vendor: '3',
          vehicle_type: 'C',
          type: 'S',
          reg_number: 'WI335EV',
          require_counter: true,
          package_id: '138'
        },
        card_1: {
          vendor: '3',
          vehicle_type: 'C',
          type: 'S',
          reg_number: 'WI240GT',
          require_counter: true,
          package_id: '138'
        },
        card_5: {
          vendor: '3',
          vehicle_type: 'C',
          type: 'S',
          reg_number: 'EPA1Y16',
          require_counter: true,
          package_id: '138'
        },
        card_6: {
          vendor: '3',
          vehicle_type: 'C',
          type: 'S',
          reg_number: 'EPA07552',
          require_counter: true,
          package_id: '138'
        },
        card_7: {
          vendor: '3',
          vehicle_type: 'C',
          type: 'S',
          reg_number: 'EPA10568',
          require_counter: true,
          package_id: '138'
        },
        card_8: {
          vendor: '3',
          vehicle_type: 'C',
          type: 'S',
          reg_number: 'WI681EF',
          require_counter: true,
          package_id: '138'
        },
        card_9: {
          vendor: '3',
          vehicle_type: 'C',
          type: 'S',
          reg_number: 'WX82089',
          require_counter: true,
          package_id: '138'
        },
        card_10: {
          vendor: '3',
          vehicle_type: 'C',
          type: 'S',
          reg_number: 'WE981LU',
          require_counter: true,
          package_id: '138'
        },
        card_11: {
          vendor: '3',
          vehicle_type: 'O',
          type: 'S',
          reg_number: 'EPA10875',
          require_counter: true,
          package_id: '138'
        },
        card_12: {
          vendor: '3',
          vehicle_type: 'O',
          type: 'S',
          reg_number: 'EPA05025',
          require_counter: true,
          package_id: '138'
        },
        card_13: {
          vendor: '3',
          vehicle_type: 'O',
          type: 'S',
          reg_number: 'EPA06771',
          require_counter: true,
          package_id: '108'
        },
        card_14: {
          vendor: '3',
          vehicle_type: 'O',
          type: 'S',
          reg_number: 'EPA07363',
          require_counter: true,
          package_id: '138'
        },
        card_2: {
          vendor: '3',
          vehicle_type: 'C',
          type: 'S',
          reg_number: 'EPA07619',
          require_counter: true,
          package_id: '115'
        },
        card_3: {
          vendor: '3',
          vehicle_type: 'C',
          type: 'S',
          reg_number: 'EPA1Y56',
          require_counter: true,
          package_id: '115'
        },
        card_4: {
          vendor: '3',
          vehicle_type: 'C',
          type: 'S',
          reg_number: 'EPA04186',
          require_counter: true,
          package_id: '115'
        }
      },
      email_low_funds: 'test@test.pl',
      email_invoice: 'test@test.pl',
      email_card_pin: 'test@test.pl',
      mobile_low_funds: '+48 510-939-790',
      mobile_card_pin: '+48 510-939-790',
      is_sms_pin_active: false,
      is_email_pin_active: true,
      is_email_invoice_active: true,
      discount_orlen: '0.00',
      discount_bliska: '0.00',
      discount_bp: '0.00',
      discount_lotos: '0.00',
      discount_lotos_lpg: '0.00',
      discount_amic: '0.00',
      discount_shell: '0.00',
      card_activation_payment_orlen: '10.00',
      card_activation_payment_bp: '10.00',
      card_activation_payment_lotos: '10.00',
      card_activation_payment_amic: '10.00',
      card_activation_payment_shell: '10.00',
      cards_same_pin: false,
      is_from_auction: false,
      customer_group_id: '19',
      customer_group_code: 'IGHP_KARTA',
      personal_data_processing_approval: true,
      username: null,
      creator: '2',
      fair_contract: false,
      monthly_declared_fuel_usage: null,
      segment: null,
      trade: null,
      deleted_at: null,
      created_at: '2020-02-17 10:05:37',
      updated_at: '2020-02-21 14:33:13'
    })
  }
}
